document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="A1RevolutionaryV2-"]');

  sections.forEach((section) => {
    const cards = Array.from(section.querySelectorAll('[data-card]'));
    const image = section.querySelector('[data-preview-image]');
    const revealItems = section.querySelectorAll('.a1rc2-reveal');

    if (!cards.length || !image) return;

    let lockedImage = image.getAttribute('src') || '';

    function switchImage(src) {
      if (!src) return;

      image.classList.add('is-switching');

      window.setTimeout(() => {
        image.src = src;
        window.setTimeout(() => {
          image.classList.remove('is-switching');
        }, 40);
      }, 140);
    }

    cards.forEach((card) => {
      const previewImage = card.dataset.image || '';

      card.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          cards.forEach((item) => item.classList.remove('is-preview'));
          card.classList.add('is-preview');
          if (previewImage) switchImage(previewImage);
        }
      });

      card.addEventListener('mouseleave', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          card.classList.remove('is-preview');
          if (lockedImage) switchImage(lockedImage);
        }
      });

      card.addEventListener('focus', () => {
        cards.forEach((item) => item.classList.remove('is-preview'));
        card.classList.add('is-preview');
        if (previewImage) switchImage(previewImage);
      });

      card.addEventListener('blur', () => {
        card.classList.remove('is-preview');
        if (lockedImage) switchImage(lockedImage);
      });

      card.addEventListener('click', () => {
        if (previewImage) {
          lockedImage = previewImage;
          switchImage(previewImage);
        }
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('a1rc2-visible');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.12 });

      revealItems.forEach((item, index) => {
        item.style.transitionDelay = `${Math.min(index * 70, 360)}ms`;
        observer.observe(item);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('a1rc2-visible'));
    }
  });
});